export default __webpack_public_path__ + "static/media/icon__11.efb1b40d.svg";